import { getLocalStorageItem, setLocalStorageItem } from '@/helpers/storage';
import { STORAGE_KEYS } from '@/constants/storageKeys';

export const getClientId = (): string => {
    let clientId = getLocalStorageItem(STORAGE_KEYS.ClientId);

    if (!clientId) {
        clientId = crypto.randomUUID();
        setLocalStorageItem(STORAGE_KEYS.ClientId, clientId);
    }

    return clientId;
};
